module.exports = __webpack_public_path__ + "static/media/Mall1959.869f23ed.jpg";